import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface Props {
  text: string;
  icon?: JSX.Element;
  textStyle?: any
}

export default function Title(props: Props) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {props.icon}
      <Typography variant="h5" style={{ ...styles.title, ...props.textStyle }}>
        {props.text}
      </Typography>
    </Stack>
  );
}

const styles = {
  title: {
    fontFamily: 'Poppins',
    fontWeight: '500',
    fontSize: '19px',
    lineHeight: '28px',
    letterSpacing: '0.4px',
    color: '#252733'
  },
}
